import styled from "@emotion/styled";
import { TOP_LAYER } from "constants/z-index";
export const StyledCarouselSelectableProductCardsGridComponent = styled.div`
  &.cluster-selected {
    animation: breatheOut 0.3s linear;
  }

  .carousel {
    .slick-slider .slick-list .slick-track {
      padding-top: 0;
    }

    &:not(:hover) {
      .carousel-arrow-wrapper.slick-arrow {
        opacity: ${({ isAutoPlay })=>isAutoPlay ? 0 : 1};
      }
    }

    &.slick-active {
      .carousel-arrow-wrapper {
        border-color: transparent;
      }
    }

    .carousel-arrow-wrapper.slick-arrow {
      opacity: 1;
      transition: opacity 0.5s ease-in-out;
      height: fit-content;
      width: fit-content;
      z-index: ${TOP_LAYER};

      &:focus {
        outline: none;
      }

      &.next {
        right: 20px;
      }

      &.prev {
        left: 20px;
      }
    }
  }

  .clusters-signup {
    margin-top: 48px;
  }
`;
